<template>
  <v-tooltip bottom :disabled="!tooltipText">
    <template #activator="{ on }">
      <v-badge
        :value="!!badgeContent"
        :content="badgeContent"
        color="primary"
        overlap
      >
        <v-btn v-bind="$attrs" icon :to="to" v-on="{ ...$listeners, ...on }">
          <v-icon small>{{ icon }}</v-icon>
        </v-btn>
      </v-badge>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
import { VTooltip, VBadge, VBtn, VIcon } from 'vuetify/lib'

export default {
  name: 'ButtonTooltip',

  components: {
    VTooltip,
    VBadge,
    VBtn,
    VIcon
  },

  props: {
    icon: {
      type: String,
      required: true
    },

    tooltipText: {
      type: String,
      required: false,
      default: null
    },

    to: {
      type: Object,
      required: false,
      default: null
    },

    badgeContent: {
      type: [Number, String],
      required: false,
      default: null
    }
  }
}
</script>
